import React from 'react';
import i18n from 'i18n-react';

import { FastFacts, ContentHeader, BackImage } from 'C4';

const FastFactsView = () => (
  <div className="fastfactsView">
    <BackImage />
    <div className="contentContainer">
      <ContentHeader
        header={i18n.translate('nav.promote')}
        subtitle={i18n.translate('pageDescriptions.promote')}
        social
      />
      <FastFacts />
    </div>
  </div>
);

export default FastFactsView;
